import { ComponentProps, PropsWithChildren, useEffect, useState } from 'react';
import { Box, Modal, Slide } from '@mui/material';
import ModalHeader from '../ModalHeader';
import ModalBottomButtons from '../ModalBottomButtons';

type ButtonProps = NonNullable<
  ComponentProps<typeof ModalHeader>['submitButton']
>;

interface Props extends PropsWithChildren {
  isOpen: boolean;
  onClose: () => void;
  name: string;
  backButton?: boolean;
  submitButton?: ButtonProps;
  secondaryButton?: Omit<ButtonProps, 'type'>;
  fullscreen?: boolean;
}

function FullScreenFloatingModal({
  isOpen,
  onClose,
  name,
  children,
  backButton,
  submitButton,
  secondaryButton,
  fullscreen = false,
}: Props) {
  // need another state to properly handle `Slide` animation
  const [isSlideOpen, setIsSlideOpen] = useState(isOpen);

  useEffect(() => {
    setIsSlideOpen(isOpen);
  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition>
      <Slide in={isSlideOpen} direction="up" mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: '#fff',
            overflow: 'hidden',
            height: {
              xs: '85vh',
              sm: '90vh',
              md: '95vh',
            },
            width: '95vw',
            maxWidth: '1600px',
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <ModalHeader
            name={name}
            handleClose={onClose}
            submitButton={submitButton}
            secondaryButton={secondaryButton}
            backButton={backButton}
            noMargin={fullscreen}
          />

          <Box
            maxWidth={!fullscreen ? '900px' : 'none'}
            margin="auto"
            width="100%"
            height="100%"
            overflow="auto"
            boxSizing="border-box"
            px={fullscreen ? 0 : 2}
            mt={fullscreen ? 0 : 3}
            pb={fullscreen ? 0 : 2}>
            {children}
          </Box>

          <ModalBottomButtons
            submitButton={submitButton}
            secondaryButton={secondaryButton}
          />
        </Box>
      </Slide>
    </Modal>
  );
}

export default FullScreenFloatingModal;
